import { render } from "./NotFound.vue?vue&type=template&id=518b20f6&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=518b20f6&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b20f6"]])

export default __exports__